<template>
  <div class="flex flex-col h-full w-full bg-n-alpha-1 dark:bg-n-solid-2">
    <iframe 
      ref="reactIframe"
      :src="iframeUrl" 
      class="w-full h-full border-none"
      @load="sendDataToReact"
    ></iframe>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();
const reactIframe = ref(null);

// Pegando dados do estado global do Chatwoot
const currentUser = computed(() => store.getters['getCurrentUser']);
const currentAccountId = computed(() => route.params.accountId);
const uiSettings = computed(() => store.getters['getUISettings']);

// Montando a URL mágica do SSO de forma segura
const iframeUrl = computed(() => {
  if (!currentUser.value || !currentAccountId.value) return '';
  
  const baseUrl = 'https://hub.eloquent.digital/';
  
  // Enviamos o token de sessão do próprio usuário para o nosso backend validar
  return `${baseUrl}?cw_token=${currentUser.value.access_token}&cw_user_id=${currentUser.value.id}&cw_account_id=${currentAccountId.value}`;
});

const sendDataToReact = () => {
  if (!reactIframe.value) return;

  const payload = {
    type: 'CHATWOOT_CONTEXT',
    data: {
      user: {
        id: currentUser.value.id,
        email: currentUser.value.email,
        name: currentUser.value.name,
        role: currentUser.value.role,
        available_name: currentUser.value.available_name
      },
      chatwootAccessToken: currentUser.access_token, // Útil se o React for fazer requests diretos no Chatwoot
      accountId: currentAccountId.value,
      theme: uiSettings.value?.color_scheme || 'light',
      locale: uiSettings.value?.locale || 'pt_BR'
    }
  };

  // IMPORTANTE: Em produção, troque '*' pelo seu domínio real (ex: 'https://app.eloquent.digital')
  reactIframe.value.contentWindow.postMessage(payload, '*');
};
</script>
